module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/handsome_2x.f9ca1b7.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/handsome_2x.png
// module id = 3hCu
// module chunks = 41